import { useState, useCallback, useEffect, useMemo, useContext } from "react"
import { useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import qs from "qs"

import { CenterModalCallbackContext } from "context/popup/CenterModalProvider"

import server from "server/serverController2"
import { getDateByTimezone } from "utils/utils"

import ConfirmCenterModal from "components/presenters/popup/ConfirmCenterModal"

const useProductChallengeAchievement = ({ productNo }) => {
  const userInfo = useSelector((state) => state.userInfo)
  const { openCenterModal, closeCenterModal } = useContext(CenterModalCallbackContext)

  const [attendeeNo, setAttendeeNo] = useState(null)
  const [isParticipate, setIsParticipate] = useState(false)
  const [isPreparing, setIsPreparing] = useState(false)
  const [minAuth, setMinAuth] = useState(0)
  const [maxAuth, setMaxAuth] = useState(0)
  const [currAuth, setCurrAuth] = useState(0)
  const [challengePeriod, setChallengePeriod] = useState(0)

  const history = useHistory()

  const loadAchievementData = useMemo(async () => {
    try {
      const queryString = qs.stringify({
        product_no: productNo,
        get_attendee_auth: true,
        get_tasks: true,
        attend_due_date_ge: getDateByTimezone("Asia/Seoul"),
      })
      const response = await server.getRequestData(
        `users/commerce/challenges/attendees?${queryString}`
      )
      if (response.success !== 1) {
        const errData = response.error.res_data
        throw errData.detail_code
      }

      const { attendees } = response.data

      return attendees[0]
    } catch (error) {
      console.log(error)
    }
  }, [productNo])

  const handleSetAchievementData = useCallback(async () => {
    const attendee = await loadAchievementData

    if (attendee?.auths) {
      setIsParticipate(true)
      setAttendeeNo(attendee.no)
      if (attendee.status === "preparing") {
        const period = attendee.period
        setChallengePeriod(period)
        setIsPreparing(true)
        return
      }

      const taskList = attendee.tasks
      const authList = attendee.auths

      let maxVal = taskList?.length ? taskList.length : 0
      let minVal = 0
      let currVal = 0
      for (const auth of authList) {
        if (auth.min_auth) {
          minVal += auth.min_auth
        }
        if (auth.curr_auth) {
          currVal += auth.curr_auth
        }
      }

      setMinAuth(minVal)
      setMaxAuth(maxVal)
      setCurrAuth(currVal)
    }
  }, [loadAchievementData])

  const handleStartChallenge = useCallback(
    async ({ modalId }) => {
      try {
        const response = await server.postRequestData(
          `commerce/challenges/attendees/${attendeeNo}/start`
        )

        if (response.success !== 1) {
          const errData = response.error.res_data
          throw errData.detail_code
        }

        closeCenterModal(modalId)
        history.replace("/task/list")
      } catch (error) {
        console.log(error)
      }
    },
    [attendeeNo, closeCenterModal, history]
  )
  const handleClickStartChallenge = useCallback(() => {
    const dataList = {
      title: "인증 시작하기",
      description: `제품을 받으셨나요?\n인증 시작버튼 클릭 시, 오늘부터\n${challengePeriod}일 후 인증기간이 종료돼요`,
    }
    openCenterModal({
      Component: (
        <ConfirmCenterModal
          dataList={dataList}
          onComplete={(id) => handleStartChallenge({ modalId: id })}
          onCancel={(id) => closeCenterModal(id)}
        />
      ),
    })
  }, [challengePeriod, closeCenterModal, handleStartChallenge, openCenterModal])

  useEffect(() => {
    if (productNo) {
      handleSetAchievementData()
    }
  }, [handleSetAchievementData, productNo])

  return {
    isParticipate,
    isPreparing,
    minAuth,
    maxAuth,
    currAuth,
    nickname: userInfo.name,
    handleClickStartChallenge,
  }
}

export default useProductChallengeAchievement
